<template>
  <div>
    <div class="formcell">
      <label :for="id" class="label">
        <slot>
          {{ labelText }}
        </slot>
      </label>
      <textarea
        :id="id"
        class="form-input input w-input form-textarea"
        :class="{
          'input-error': error,
          'input-success': success,
        }"
        :value="value"
        :maxlength="maxLength"
        :placeholder="placeholder"
        @input="handleInput"
      />
      <span v-if="error" class="error-message">{{ errorMessageText }}</span>
      <span v-else class="info-message">{{ inputInfo }}</span>
    </div>
  </div>
</template>

<script>
  import inputErrors from '@/utils/mixins/input-errors';

  export default {
    name: 'TextArea',
    mixins: [inputErrors],
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      value: String,
      id: {
        type: String,
        required: true,
      },
      required: {
        type: Boolean,
        required: false,
        default: false,
      },
      placeholder: {
        type: String,
        required: false,
        default: '',
      },
      labelText: {
        type: String,
        required: true,
      },
      maxLength: Number,
    },
    methods: {
      handleInput(event) {
        this.$emit('input', event.target.value);
      },
    },
  };
</script>

<style lang="scss">
  @import 'src/styles/components/input';
  .form-textarea {
    min-height: 64px;
    padding: 12px;
  }
</style>
